import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Button from "../../components/controls/Button";
import Form from "../../components/Form/Form";
import useForm from "../../components/Form/useForm";
import Spinner from "../../components/Spinner/Spinner";
import { hasObjectAllValuesEmpty } from "../../utils/helpers";
import TextField from '@mui/material/TextField';
import "./NewUserForm.scss";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined';
import { useHistory } from "react-router-dom";
import { Modal } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import Link from '@mui/material/Link';
import Notification from "../../components/Notification/Notification";
import { createNotifyError } from "../../utils/helpers";
import CheckIcon from "../../assets/icons/CheckIcon";
import CloseIcon from '@mui/icons-material/Close';
import { InfoOutlined } from "@material-ui/icons";

import { getProvinces } from "../../service/api/CountriesSevice";
import MenuItem from '@mui/material/MenuItem';
import { Typography, Select, InputLabel } from "@mui/material";



const NewUserForm = ({
  addOrEdit,
  loading,
  setLoading,
  style,
  showErrorUserExists,
  togglePrivacyInfo,
  toggleCookiesInfo,
  toggleTermsInfo,
  privacyAccepted,
  termsAccepted,
  cookiesAccepted,
  values,
  setValues,
  fields,
  initialValues,
  errors,
  setErrors,
  showModal,
  captchaRef }) => {

  const [showPrivacyInfo, setShowPrivacyInfo] = useState(false);
  const [showTermsInfo, setShowTermsInfo] = useState(false);
  const [showCookiesInfo, setShowCookiesInfo] = useState(false);
  const [notification, setNotification] = useState(undefined);
  const [captchaValid, setCaptchaValid] = useState(false);


  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    fields.forEach((value) => {
      if (value.field in fieldValues && value.validation)
        if (value.field === "repeatPassword") {
          value.validation.forEach((validation) => {
            temp[value.field] = validation(
              fieldValues[value.field],
              values["password"],
            );
          });
        }
        else {
          value.validation.forEach((validation) => {
            temp[value.field] = validation(fieldValues[value.field]);
          });
        }

    });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };


  const [showPassword, setShowPassword] = useState(false);
  const [provincesList, setProvincesList] = useState(null);
  const selectRef = useRef(null);
  const [menuWidth, setMenuWidth] = useState(null);


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { handleInputChange } = useForm(
    initialValues,
    validate,
    true,
    null,
    values,
    setValues,
    errors,
    setErrors
  );

  const handleSubmit = () => {
    if (validate()) {
      setLoading(true);
      addOrEdit(values);
    }
    else {
      setNotification(createNotifyError(""))
    }
  };

  const getProvince= () => {
    if (provincesList) {
        return provincesList.map((el) => {
            return <MenuItem key={el.provinceCode} value={el.provinceCode}><Typography noWrap> {el.provinceLabel}</Typography></MenuItem >;
        });
    }
    return null;
}

  const renderFields = (begin, end) => {
    return fields
      .slice(begin, end)
      .map((value) => (
         (value.field !== "province") ? (
        <TextField
          type={value.type || ""}
          key={value.field}
          label={value.headerName}
          name={value.field}
          error={errors.hasOwnProperty(value.field) && errors[value.field] !== ""}
          value={
            values[value.field] == null ? "" : values[value.field].toString()
          }
          onChange={handleInputChange}
          variant="outlined" fullWidth
          className="input-form"
          autoComplete="on"
        />) :
        <FormControl fullWidth>
          <InputLabel id={value.headerName}>{value.headerName}</InputLabel>
        <Select
            ref = {selectRef}
            label={value.headerName}
            labelId={value.headerName}
            name={value.field}
            onChange={handleInputChange}
            placeholder={value.headerName}
            value={provincesList && values[value.field] == null ? "" : values[value.field].toString()}
            MenuProps={{
              MenuListProps: {
                sx: {
                  "li.MuiButtonBase-root": {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    width: menuWidth,
                    padding: "0.5rem"
                  },
                },
              },
            }}
        >
            {getProvince()}
        </Select>
        </FormControl>
      ));
  };

  useEffect(() => {
    togglePrivacyInfo(showPrivacyInfo);
  }, [togglePrivacyInfo, showPrivacyInfo]);

  useEffect(() => {
    toggleTermsInfo(showTermsInfo);
  }, [toggleTermsInfo, showTermsInfo]);

  useEffect(() => {
    toggleCookiesInfo(showCookiesInfo);
  }, [toggleCookiesInfo, showCookiesInfo]);

  useEffect(() => {
    getProvinces().then(data => {
      setProvincesList(data)
  });
  if (selectRef.current) {
    const width = selectRef.current.offsetWidth;
    setMenuWidth(width);
  }
    // eslint-disable-next-line
  }, [])

  const handleCloseModal = () => {
    redirect();
  }

  let history = useHistory();

  const redirect = () => {
    history.push({
      pathname: `/user-confirm`,
    })
  }

  const handleCaptcha = () => {
    setCaptchaValid(true);
  }

  return (
    <>
      <Form onSubmit={handleSubmit} style={style}>
        <div className="newuserform row">
          {notification && (
            <Notification
              notification={notification}
              setNotification={setNotification}
            />
          )}
          <div>{renderFields(0, 9)}</div>
          <div>
            <TextField
              type={showPassword ? 'text' : 'password'}
              value={values.password}
              onChange={handleInputChange}
              name="password"
              label="Contraseña"
              autoComplete="on"
              error={errors.password != null && errors.password !== ''}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                    </IconButton>
                  </InputAdornment>
              }}
            />

            <TextField
              type={showPassword ? 'text' : 'password'}
              value={values.repeatPassword}
              onChange={handleInputChange}
              name="repeatPassword"
              label="Repetir Contraseña"
              error={errors.repeatPassword != null && errors.repeatPassword !== ''}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
          </div>
          <FormHelperText id="component-helper-text"><InfoOutlined className="me-2 text-info" />La contraseña debe contener entre 8 y 50 caracteres, incluyendo una
            letra mayúscula, una letra minúscula y un número y símbolo
          </FormHelperText>

          {showErrorUserExists ? <div className="error-user-exists">El usuario ya existe</div> : null}

          <div className="checkbox-group">
            <div className="label-text-checkbox pt-5">
              <FormControlLabel
                control={
                  <Checkbox
                    label="sendComercialInfo"
                    checked={values.sendComercialInfo}
                    name="sendComercialInfo"
                    onChange={handleInputChange}
                    color="default" />
                }
              />Acepto recibir Información Comercial.
            </div>
            <div className="label-text-checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    label="privacyAccepted"
                    checked={privacyAccepted}
                    name="privacyAccepted"
                    color="default"
                    disabled />
                }
              />Entiendo y acepto la
              <Link className="bold-link-separator" onClick={() => setShowPrivacyInfo(!showPrivacyInfo)}>
                Política de Privacidad.</Link>
            </div>
            <div className="label-text-checkbox">
              <FormControlLabel
                className="form-signup-checkbox"
                control={
                  <Checkbox
                    label="termsAccepted"
                    checked={termsAccepted}
                    name="termsAccepted"
                    color="default"
                    disabled />
                }
              />Entiendo y acepto los<Link className="bold-link-separator" onClick={() => setShowTermsInfo(!showTermsInfo)}>Términos y Condiciones.</Link>
            </div>
            <div className="label-text-checkbox">
              <FormControlLabel
                className="form-signup-checkbox"
                control={
                  <Checkbox
                    label="cookiesAccepted"
                    checked={cookiesAccepted}
                    name="cookiesAccepted"
                    color="default"
                    disabled />
                }
              />Entiendo y acepto las<Link className="bold-link-separator" onClick={() => setShowCookiesInfo(!showCookiesInfo)}>Políticas de cookies.</Link>
            </div>
            {  !cookiesAccepted || !termsAccepted || !privacyAccepted ?
              <div className="col-12 helper-text-checkbox">
                <FormControl
                  required
                  component="fieldset"
                  sx={{ m: 3 }}
                  variant="standard"
                >
                  <FormHelperText className="col-11 text-secondary"><InfoOutlined className="me-2 text-info" />Para continuar, debes dar click en los enlaces y confirmar que
                    has leído las Políticas de Privacidad y los Términos y condiciones.</FormHelperText>
                </FormControl>
              </div>
              : null}
          </div>

          <div className="captcha mt-3">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_ENV}
              ref={captchaRef}
              style={{ display: "inline-block" }}
              onChange={handleCaptcha}
            />
          </div>

          <div className="mt-xl-5 d-flex d-inline justify-content-center mt-3">
            {loading ? (
              <Spinner />
            ) : (
              <>
                <Button
                  className="button-send"
                  type="submit"
                  text="Enviar"
                  disabled={!hasObjectAllValuesEmpty(errors) || !cookiesAccepted || !termsAccepted || !privacyAccepted || !captchaValid}
                />
              </>
            )}
          </div>
        </div>
      </Form>
      <Modal
        open={showModal}
        onClose={handleCloseModal}
        className="modal-container">
        <div className="pop-up-modal col-xl-6 col-12">
          <Button className="col close-icon" id="redirect-button" onClick={redirect}>
            <span ><CloseIcon /></span>
          </Button>
          <div className="row ">
            <div className="col-xl-12 col-12 mt-5 pt-5 ms-4 text-center"> <CheckIcon /></div>
          </div>
          <div className="col-xl-8 m-auto text-center mt-3">
            <h2>¡Formulario enviado!</h2>
          </div>
          <div>
            <div className="col-xl-8 px-5 m-auto text-center mt-4">
              <p>Encontrarás las instrucciones
                para completar el registro en tu dirección de correo electrónico.<br></br>
                <strong>No cierres el navegador</strong> hasta completar el proceso de alta.</p>
              <Button className="button-continue mb-3" onClick={redirect}>Continuar</Button>
            </div>
          </div>
        </div>
      </Modal >
    </>

  );
};

NewUserForm.propTypes = {
  addOrEdit: PropTypes.func,
};

export default NewUserForm;
